import { Form, Select } from "antd";
import { useEffect } from "react";
const { Option } = Select;

function CountryCode(props) {
  return (
    <Form.Item
      name={props?.name}
      noStyle
      //initialValue="+1"
      initialValue="Cell"
      rules={[
        {
          required: true,
          message: "Please select a countryCode",
        },
      ]}
    >
      <Select
        style={{
          width: 90,
        }}
        disabled={props?.SelPatient}
      >
        {/* <Option value="+91">+91</Option>
        <Option value="+1">+1</Option> */}
        <Option value="Home">Home</Option>
        <Option value="Cell">Cell</Option>
        <Option value="Office">Office</Option>
      </Select>
    </Form.Item>
  );
}

export default CountryCode;
